// Keep every answer matching the played prefix until the learner picks a branch.
export class BookExercise {
 constructor(lines){this.lines=lines;this.reset();}
 reset(){this.prefix=[];this.candidates=this.lines.map((_,i)=>i);this.lineIndex=0;this.complete=false;}
 play(uci){
  const at=this.prefix.length;let matches=this.candidates.filter(i=>this.lines[i].moves[at]?.uci===uci);
  if(!matches.length)return {accepted:false};
  this.prefix.push(uci);this.candidates=matches;
  let ended=matches.find(i=>this.lines[i].moves.length===this.prefix.length),reply=null;
  if(ended===undefined){reply=this.lines[matches[0]].moves[this.prefix.length].uci;
   matches=matches.filter(i=>this.lines[i].moves[this.prefix.length]?.uci===reply);
   this.prefix.push(reply);this.candidates=matches;ended=matches.find(i=>this.lines[i].moves.length===this.prefix.length);
  }
  this.complete=ended!==undefined;this.lineIndex=ended??matches[0];const ply=this.prefix.length;
  return {accepted:true,completed:this.complete,lineIndex:this.lineIndex,ply,reply,fen:this.lines[this.lineIndex].moves[ply-1].fenAfter};
 }
}
